export default __webpack_public_path__ + "static/media/018-monk.c174de91.svg";